import { render, staticRenderFns } from "./Arrows.vue?vue&type=template&id=59088f36&scoped=true&"
import script from "./Arrows.vue?vue&type=script&lang=js&"
export * from "./Arrows.vue?vue&type=script&lang=js&"
import style0 from "./Arrows.vue?vue&type=style&index=0&id=59088f36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59088f36",
  null
  
)

export default component.exports